import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';
import {createLogger} from 'redux-logger';
import rootReducer from '../reducers';
import {configureResultsClient, resultsMiddleWare} from 'athlinks-results-client'
import {configs} from '../configs'
import { combineEpics, createEpicMiddleware } from 'redux-observable'
import { getUserPrefsEpic } from '../epics/getUserPrefsEpic'
import { setUserPrefsEpic } from '../epics/setUserPrefsEpic'
import { mapCheckEpic } from '../epics/mapCheckEpic'

const logger = createLogger({
  level: 'info',
  collapsed: true
});

configureResultsClient(`${configs.resultsApiUrl}`, configs.resultsHubUrl);

const rootEpic = combineEpics(
  getUserPrefsEpic,
  setUserPrefsEpic,
  mapCheckEpic,
)

const epicMiddleware = createEpicMiddleware()

const enhancer = compose(
  __DEVELOPMENT__ ? applyMiddleware(logger, resultsMiddleWare, epicMiddleware) : applyMiddleware(resultsMiddleWare, epicMiddleware)
);

export default () => {
  const store = createStore(rootReducer, enhancer)
  epicMiddleware.run(rootEpic)
  return store
}



/** WEBPACK FOOTER **
 ** ./store/configureStore.js
 **/